const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/britax-add-order-template-to-cart.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-add-order-template-to-cart.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-assets.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-assets.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-atp-date.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-atp-date.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-dimensions-for-selected-variant.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-dimensions-for-selected-variant.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-dimensions.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-dimensions.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-search-suggestion.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-search-suggestion.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-get-specific-case.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-get-specific-case.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/britax-post-case.action';
            binding.dataActions[actionPath] = require('partner/actions/britax-post-case.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-dropship-attributes.action';
            binding.dataActions[actionPath] = require('partner/actions/get-dropship-attributes.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/getnotes.action';
            binding.dataActions[actionPath] = require('partner/actions/getnotes.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/gettrackingid.action';
            binding.dataActions[actionPath] = require('partner/actions/gettrackingid.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/post-product-claim.action';
            binding.dataActions[actionPath] = require('partner/actions/post-product-claim.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/updatecase.action';
            binding.dataActions[actionPath] = require('partner/actions/updatecase.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };